import React from 'react';
import { connect } from 'react-redux';

import ChooseOrganizationForm from './ChooseOrganizationForm';
import DeactivatedBanner from './DeactivatedBanner';
import * as duckActions from './duck';

import { Spinner } from '$HVUI';

export class ChooseOrganization extends React.Component {
    componentDidMount() {
        const {
            company: { id }
        } = this.props;
        this.props.loadOrganizationChoices(id);
    }
    redirectToOrg() {
        // As of Feb 2019, only organization specific URLs
        // (formerly known as "org_locked") are used for
        // registration.
        // Let the backend set the cookies properly.
        return window.location.assign(`/reg/${this.props.organization.id}`);
    }
    render() {
        const {
            organization,
            organizationChoices,
            company: { title: companyTitle }
        } = this.props;

        if (organization && organization.id) {
            this.redirectToOrg();
            return <div>Setting clinic location...</div>;
        }

        const form = () => {
            if (!organizationChoices || !organizationChoices.length) {
                return (
                    <Spinner
                        id="org-choose-loading"
                        style={{ width: '50px', margin: '3em' }}
                    />
                );
            }
            return (
                <ChooseOrganizationForm
                    organizationChoices={organizationChoices}
                    onSubmit={this.props.chooseOrganization}
                    label={'Select Your Clinic / Selecciona tu clínica'}
                    text={'Submit / Enviar'}
                />
            );
        };

        if (organization?.is_inactive) {
            return <DeactivatedBanner companyTitle={companyTitle} />;
        }

        return (
            <>
                <h1 style={{ marginTop: '32px' }}>{companyTitle}</h1>
                <h2 style={{ marginTop: '32px' }}>
                    {
                        'Choose your clinic location / Elige la ubicación de tu clínica'
                    }
                </h2>
                {form()}
            </>
        );
    }
}

export const mapStateToProps = (state, ownProps) => {
    const { introduction } = state;
    let organizationChoices =
        introduction && introduction.organizationChoices
            ? introduction.organizationChoices.map(org => [
                  org.id,
                  org.short_name
              ])
            : [];

    if (organizationChoices && organizationChoices.length) {
        organizationChoices.unshift(['', '---']);
    }

    return Object.assign(
        {},
        {
            company: introduction.company || {},
            organization: introduction.organization,
            organizationChoices
        },
        ownProps
    );
};

export default connect(mapStateToProps, duckActions)(ChooseOrganization);
